import React, { Component } from 'react';
import { Card, Button, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Fetcher } from '../../../Helpers/fetcher.js';
import { Notify } from '../../../Helpers/notification.js';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

const DOCUMENT_TYPE_LABELS = {
	SIMPLE_DOCUMENT: 'Simple Document',
	TEMPLATE_1: 'TEMPLATE 1',
	TEMPLATE_2: 'TEMPLATE 2',
	TEMPLATE_3: 'TEMPLATE 3',
	TEMPLATE_4: 'TEMPLATE 4',
	TEMPLATE_5: 'TEMPLATE 5',
	TEMPLATE_6: 'TEMPLATE 6',
	TEMPLATE_7: 'TEMPLATE 7',
	TEMPLATE_8: 'TEMPLATE 8',
	TEMPLATE_9: 'TEMPLATE 9'
};

const formatFileSize = (bytes) => {
	if (!bytes && bytes !== 0) return '';
	if (bytes < 1024) return bytes + ' B';
	if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
	return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

class UploadDocument extends Component {
	constructor(props) {
		super(props);
		this.state = {
			documentList: [],
			loading: true,
			sizePerPage: 10,
			confirmDelete: false,
			selectedId: null
		}
	}

	componentDidMount() {
		if (this.props.app.role !== 'ROLE_SADMIN' && this.props.app.role !== 'ROLE_SUB_SADMIN') {
			this.props.history.replace('/');
			return;
		}
		this.getDocumentList();
		const savedSizePerPage = Cookies.get('appDocumentListSizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}

	getDocumentList = () => {
		const apiPath = this.props.app.apiPath;
		const userId = this.props.app.userId;
		this.setState({ loading: true });
		Fetcher.get(apiPath + '/api/obd/document/list/' + userId)
			.then(res => {
				this.setState({ documentList: Array.isArray(res) ? res : [] });
			})
			.catch(err => {
				console.log('Error in fetching Document List', err);
				Notify.notify('Error in fetching Document List');
			})
			.finally(() => this.setState({ loading: false }));
	}

	confirmDelete = (status, id) => {
		this.setState({ confirmDelete: status, selectedId: id });
	}

	deleteDocument = () => {
		const apiPath = this.props.app.apiPath;
		const data = { id: this.state.selectedId };
		Fetcher.post(apiPath + '/api/obd/document/delete', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.setState({ confirmDelete: false, selectedId: null });
				this.getDocumentList();
			})
			.catch(err => {
				console.log('Error in deleting Document', err);
				Notify.notify('Error in deleting Document');
			});
	}

	downloadDocument = (id, fileName) => {
		const apiPath = this.props.app.apiPath;
		const token = Cookies.get('token');
		fetch(apiPath + '/api/obd/document/download/' + id, {
			headers: { 'Authorization': 'Bearer ' + token }
		})
			.then(res => {
				if (!res.ok) throw new Error('Download failed');
				return res.blob();
			})
			.then(blob => {
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = fileName;
				link.click();
			})
			.catch(err => {
				console.log('Error in downloading Document', err);
				Notify.notify('Error in downloading Document');
			});
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('appDocumentListSizePerPage', newSizePerPage);
	}

	render() {
		const urlPrefix = this.props.app.urlPrefix || '';
		const columns = [
			{ dataField: 'id', text: 'Id', sort: true },
			{ dataField: 'documentName', text: 'Document Name', sort: true, searchable: true },
			{ dataField: 'documentTypeLabel', text: 'Document Type', sort: true },
			{ dataField: 'fileInfo', text: 'File', sort: false },
			{ dataField: 'uploadedByName', text: 'Uploaded By', sort: true },
			{ dataField: 'createdAt', text: 'Uploaded At', sort: true },
			{
				dataField: 'action',
				text: 'Action',
				isDummyField: true,
				csvExport: false,
				formatter: (_, row) => (
					<>
						<Button variant="primary" size="sm" className="mr-1" onClick={() => this.downloadDocument(row.id, row.originalFileName)}>Download</Button>
						<Button variant="danger" size="sm" onClick={() => this.confirmDelete(true, row.id)}>Delete</Button>
					</>
				)
			}
		];

		const documents = Array.isArray(this.state.documentList) ? this.state.documentList.map(d => ({
			id: d.id,
			documentName: d.documentName,
			documentTypeLabel: DOCUMENT_TYPE_LABELS[d.documentType] || d.documentType,
			originalFileName: d.originalFileName,
			fileInfo: `${d.originalFileName} (${formatFileSize(d.fileSize)})`,
			uploadedByName: d.uploadedByName,
			createdAt: d.createdAt
		})) : [];

		const { SearchBar, ClearSearchButton } = Search;
		const { ExportCSVButton } = CSVExport;

		const paginationOption = {
			custom: true,
			totalSize: documents.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		return (
			<Card>
				<Card.Header>Upload Document</Card.Header>
				<Card.Body>
					<PaginationProvider pagination={paginationFactory(paginationOption)}>
						{({ paginationProps, paginationTableProps }) => (
							<ToolkitProvider keyField="id" data={documents} columns={columns} search bootstrap4>
								{props => (
									<div>
										Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
										<span className="search-cont"><SearchBar {...props.searchProps} /></span>
										<ClearSearchButton className="btn-primary" {...props.searchProps} />
										<ExportCSVButton className="export-csv btn-primary ml-2" {...props.csvProps}>Export to CSV</ExportCSVButton>
										<Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.getDocumentList()}>Refresh</Button>
										<Link to={`${urlPrefix}/superadmin-api-docs/upload-document/add`} className="float-right btn btn-primary ml-2">Upload Document</Link>
										<hr />
										<BootstrapTable
											bordered
											hover
											wrapperClasses="table-responsive"
											classes="w-auto"
											{...props.baseProps}
											{...paginationTableProps}
											noDataIndication={() => this.state.loading
												? <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>
												: <div>No data available</div>}
										/>
										<PaginationListStandalone {...paginationProps} />
									</div>
								)}
							</ToolkitProvider>
						)}
					</PaginationProvider>
				</Card.Body>

				<Modal size="sm" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, null)}>
					<Modal.Header closeButton>
						<Modal.Title>Delete Document</Modal.Title>
					</Modal.Header>
					<Modal.Body>Are you sure you want to delete this document?</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={() => this.confirmDelete(false, null)}>Cancel</Button>
						<Button variant="danger" onClick={this.deleteDocument}>Delete</Button>
					</Modal.Footer>
				</Modal>
			</Card>
		);
	}
}

export default UploadDocument;
